import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import CommonButton from '../../../../../components/common-button/CommonButton';
import Icon from '../../../../../icons/Icon';
import { ICONS } from '../../../../../icons';

const ImportDataset = ({ isLoading, disabled, onSubmit }) => {
  const { t } = useTranslation('projects');

  const hiddenFileInput = useRef(null);

  const handleOpenChooseFile = useCallback(() => {
    hiddenFileInput.current.click();
  }, []);

  const handleFileChange = useCallback(
    (e) => {
      const file = e.target.files[0];
      if (file) {
        onSubmit(file);
      }
    },
    [onSubmit],
  );

  return (
    <>
      <CommonButton styleColor='secondary' onClick={handleOpenChooseFile} disabled={isLoading || disabled}>
        <Icon icon={ICONS.Import} />
        {t('import')}
      </CommonButton>

      <input
        type='file'
        id='sonar-dataset-import'
        name='sonar-dataset-import'
        onChange={handleFileChange}
        ref={hiddenFileInput}
        style={{ display: 'none' }}
      />
    </>
  );
};

export default ImportDataset;
